import { ApisauceInstance, create } from 'apisauce'

import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import { isAPISuccess } from '@flowwai-frontend/shared/api-common'
import {
   HTTP_ACCEPT_HEADER_VALUE,
   HTTP_CACHE_CONTROL_HEADER_VALUE,
   HTTP_CONTENT_TYPE_HEADER_VALUE,
   HTTP_PRAGMA_HEADER_VALUE
} from '@flowwai-frontend/shared/auth/common'

import endpoints from '../endPoints'
import {
   LoginWithEmailRequestType,
   LoginWithEmailResponseType,
   ReSendEmailOTPAPIRequestType,
   VerifyEmailOTPAPIRequestType,
   VerifyEmailOTPAPIResponseType
} from '../types'

import LoginService from './'

const BASE_URL = Config.BACKEND_REST_URL

const LOGIN_URL = `${BASE_URL}api/iam/`

export class LoginServiceAPI implements LoginService {
   api: ApisauceInstance
   constructor() {
      this.api = create({
         baseURL: LOGIN_URL,
         headers: {
            'Content-Type': HTTP_CONTENT_TYPE_HEADER_VALUE,
            Accept: HTTP_ACCEPT_HEADER_VALUE,
            Pragma: HTTP_PRAGMA_HEADER_VALUE,
            'Cache-Control': HTTP_CACHE_CONTROL_HEADER_VALUE
         }
      })
   }
   loginWithEmail = async (requestObject: LoginWithEmailRequestType) => {
      const response = await this.api.post<
         LoginWithEmailResponseType | unknown
      >(endpoints.loginWithEmail, requestObject)

      if (isAPISuccess(response.status)) return response.data

      throw response.data
   }

   resendEmailOTP = async (requestObject: ReSendEmailOTPAPIRequestType) => {
      const response = await this.api.post<void>(
         endpoints.sendOTP,
         requestObject
      )

      if (isAPISuccess(response.status)) return response.data

      throw response.data
   }

   verifyEmailOTP = async (requestObject: VerifyEmailOTPAPIRequestType) => {
      const response = await this.api.post<
         VerifyEmailOTPAPIResponseType | unknown
      >(endpoints.verifyOTP, requestObject)

      if (isAPISuccess(response.status)) return response.data

      throw response.data
   }
}
